import React, { useEffect, useCallback, memo } from 'react';
import { FormGroup, Row, Col, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import ServiceCRUDChatTS from '../../../../services/ServiceCRUDCHATTS';
import { FlexControllerV2 } from 'components/FlexControllerInput/V2';
import { useForm } from 'react-hook-form';

const pullChatService = new ServiceCRUDChatTS('/configurations/pull-chat');

const toastConfig = {
  autoClose: 3000,
  closeOnClick: true
};

export const SimultaneousChatsLimit = memo(() => {
  const {
    control,
    reset,
    errors,
    watch,
    formState: { isDirty }
  } = useForm();

  const active = !!watch('active');
  const maxPullChat = watch('maxPullChat') ?? 0;

  const loadPullChatConfig = useCallback(async () => {
    try {
      const { data: config } = await pullChatService.get();

      if (Object.keys(reset)) reset(config);
    } catch (error) {
      toast.error('Nenhuma configuração de limite de conversas!', toastConfig);
    }
  }, []);

  const handleUpdate = useCallback(async () => {
    try {
      const payload = {
        active: active,
        maxPullChat: maxPullChat
      };

      await pullChatService.put('', payload);

      loadPullChatConfig();

      toast.success('Configuração atualizada com sucesso!', toastConfig);
    } catch (error) {
      toast.error('Erro ao atualizar configuração!', toastConfig);
      console.error('Error updating simultaneous chats limit:', error);
    }
  }, [active, maxPullChat]);

  useEffect(() => {
    loadPullChatConfig();
  }, [loadPullChatConfig]);

  return (
    <Row>
      <Col>
        <FormGroup check className="mb-3">
          <FlexControllerV2
            type="checkbox"
            name="active"
            control={control}
            errors={errors}
            label="Ativar limite de resgates simultâneos"
          />
        </FormGroup>

        {active && (
          <FormGroup>
            <FlexControllerV2
              label="Quantidade de conversas a serem resgatadas por vez"
              name="maxPullChat"
              type="number"
              control={control}
              errors={errors}
            />
          </FormGroup>
        )}

        {isDirty && (
          <Button color="primary" onClick={handleUpdate} className="mt-3">
            Salvar alterações
          </Button>
        )}
      </Col>
    </Row>
  );
});

SimultaneousChatsLimit.displayName = 'SimultaneousChatsLimit';
